export enum MissingProfileDataFieldType {
  Text = 'text',
  Email = 'email',
  Date = 'date',
  BooleanType = 'boolean'
}
